module.exports = __webpack_public_path__ + "img/wangjimima3.fc1ec5d6.png";